export function suggestedColumn(index: number | null | undefined): string {
  if (index == null) return '';
  return String(index);
}

export function columnsFromSuggestions(
  partyKey: string,
  internalKey: string,
  partyIndex: number | null | undefined,
  internalIndex: number | null | undefined,
): Record<string, string> {
  return {
    [partyKey]: suggestedColumn(partyIndex),
    [internalKey]: suggestedColumn(internalIndex),
  };
}

function columnsAreDistinct(
  partyColumn: string,
  internalColumn: string,
): boolean {
  if (partyColumn === '') return false;
  if (internalColumn === '') return false;
  return partyColumn !== internalColumn;
}

function hasUploadTarget(input: {
  partyId?: string;
  documentId: string | null;
  hasPreview: boolean;
}): boolean {
  if (!input.partyId) return false;
  if (!input.documentId) return false;
  return input.hasPreview;
}

export function canSubmitBulkUpload(input: {
  partyId?: string;
  documentId: string | null;
  hasPreview: boolean;
  partyColumn: string;
  internalColumn: string;
  busy: boolean;
}): boolean {
  if (input.busy) return false;
  if (!hasUploadTarget(input)) return false;
  return columnsAreDistinct(input.partyColumn, input.internalColumn);
}

export function errorMessage(err: unknown, fallback: string): string {
  if (err instanceof Error && err.message) return err.message;
  return fallback;
}

export function columnIndex(value: string): number {
  return Number(value);
}

export function toBulkResultView<
  TRow extends { rowIndex: number; internalPart: string },
>(
  result: {
    createdCount: number;
    mergedCount: number;
    unmatchedCount: number;
    skippedRows: number;
    unmatchedTruncated: boolean;
    unmatched: readonly TRow[];
  },
  partyPart: (row: TRow) => string,
) {
  return {
    createdCount: result.createdCount,
    mergedCount: result.mergedCount,
    unmatchedCount: result.unmatchedCount,
    skippedRows: result.skippedRows,
    unmatchedTruncated: result.unmatchedTruncated,
    unmatched: result.unmatched.map((row) => ({
      rowIndex: row.rowIndex,
      partyPart: partyPart(row),
      internalPart: row.internalPart,
    })),
  };
}
